import request from 'helpers/request';

export default async function parameters() {
  const response = await request('/api/v2/finance/parameters', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    mode: 'cors',
  });

  return response.data.Parameters;
}
